import { create } from 'zustand';

interface IProgressDialogState {
  isVisible: boolean;
  text: string | null;
}

const DEFAULT_STATE: IProgressDialogState = { isVisible: false, text: null };

interface IProgressDialogStore extends IProgressDialogState {
  show: (params: { text: string }) => void;
  hide: () => void;
}

export const useProgressDialogStore = create<IProgressDialogStore>(set => ({
  ...DEFAULT_STATE,
  show: ({ text }) => set({ isVisible: true, text }),
  hide: () => set(DEFAULT_STATE),
}));
